import axios from "axios";

const fetchAll = (params, config) => {
  return axios.get("/api/v1/digia_customers", { params, ...config });
};

const restart = (params) => {
  return axios.post("/api/v1/digia_customers/restart", params);
};

const ApiDigiaCustomers = {
  fetchAll,
  restart,
};

export default ApiDigiaCustomers;
